import { inventoryItemIdFormat } from "@redotech/redo-inventory-id";
import { processingSessionIdFormat } from "@redotech/redo-return-id";
import {
  warehouseFlaggedProblemIdFormat,
  warehouseFlaggedProblemReasonIdFormat,
} from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const recordItemReviewFailure = {
  name: "recordItemReviewFailure" as const,
  input: z.object({
    inventoryItemId: inventoryItemIdFormat.schema,
    sessionId: processingSessionIdFormat.schema,
    reasonId: warehouseFlaggedProblemReasonIdFormat.schema.optional(),
    note: z.string().trim().min(1).optional(),
  }),
  output: z.object({ id: warehouseFlaggedProblemIdFormat.schema }),
};
